import { JSX, useState } from "react"
import mainservice from "../../../services/MainService"
import { Box, Button, Stack, Typography } from "@mui/material"

type CopySetting = {
  key: string,
  text: string,
  value: boolean,
  display: boolean,
}

type FinishFkt = (params: {
  copySettings: EventCopyModalState,
  action: 'cancel' | 'ok'
}) => void

type optionListKey = 'copy' | 'copyAsDesign'

function CopySettings(mode: optionListKey): CopySetting[] {
  switch(mode) {
    case 'copy':
      return [
        {
          key: 'copyTrainer',
          text: 'Trainer übernehmen',
          value: false,
          display: true,
        },
        {
          key: 'copyParticipants',
          text: 'Teilnehmer übernehmen',
          value: false,
          display: true,
        },
        {
          key: 'copyAppointments',
          text: 'Zeiträume übernehmen',
          value: false,
          display: true,
        }
      ]
    case 'copyAsDesign':
      return [
        {
          key: 'copyTrainer',
          text: 'Trainer',
          value: false,
          display: false,
        }
      ]
  }
  return []
}

export class EventCopyModalState {
  copySettings: CopySetting[]
  constructor(props: {
    mode: optionListKey
  }) {
    this.copySettings = CopySettings(props.mode)
  }
  list() {
    return this.copySettings
  }
  setSetting(key: string, value: boolean) {
    const index = this.copySettings.findIndex(s => s.key === key)
    if (index !== -1) {
      this.copySettings[index].value = value
    }
  }
  get(key: string) {
    const index = this.copySettings.findIndex(s => s.key === key)
    if (index !== -1) {
      return this.copySettings[index].value
    }
    return undefined
  }
}
export default function EventCopyModal(props: {
  finishFkt: FinishFkt,
  headline: string,
  description: string,
  okayString?: string,
  cancelString?: string,
  okayStartIcon?: JSX.Element,
  okayEndIcon?: JSX.Element,
  mode: optionListKey,
}) {
  const [copySettings] = useState(new EventCopyModalState(props))
  const [rerender, setRerender] = useState(0)
  return <Stack spacing={2}>
    <Typography variant="h4">{props.headline}</Typography>
    <Box>
      {props.description}
    </Box>
    <Box>
      {
        copySettings.list().map((copySetting: CopySetting) => {
          if (!copySetting.display) {
            return null
          }
          return <Box key={`modal-${copySetting.key}`}>
            <input
              className="w3-check"
              type='checkbox'
              checked={copySetting.value}
              onChange={() => {
                copySettings.setSetting(copySetting.key, !copySetting.value)
                setRerender(rerender + 1)
              }}
              />
              <label className="w3-margin">{copySetting.text}</label>
          </Box>
        })
      }
    </Box>
    <Box>
      <Stack spacing={2} direction="row">
        <Button
          startIcon={props.okayStartIcon}
          endIcon={props.okayEndIcon}
          variant="contained"
          onClick={() => {
            props.finishFkt({
              copySettings: copySettings,
              action: 'ok'
            })
            mainservice.broadcast('openmodal', {content: null})
          }}
        >
          {props.okayString || 'OK'}
        </Button>
        <Button
          variant="outlined"
          onClick={() => mainservice.broadcast('openmodal', {content: null})}
        >
          {props.cancelString || 'Abbrechen'}
        </Button>
      </Stack>
      
    </Box>
  </Stack>
}
